import type { RunnerId } from '@swf/generated/types/api/sports';

import { initialState } from '../../betSlip';
import type { BetSlipState } from '../../types/betSlip';

const selectionRemoved = (state: BetSlipState, payload: RunnerId[]): BetSlipState => {
  const selectionsToRemain = state.selections.filter(
    (betSlipSelection) =>
      !payload.find(
        (payloadSelection) =>
          betSlipSelection.selectionId === payloadSelection.selectionId &&
          betSlipSelection.marketId === payloadSelection.marketId
      )
  );

  return {
    ...state,
    selections: selectionsToRemain,
    selectedPromotionPicker: initialState.selectedPromotionPicker,
    ...(selectionsToRemain.length === 0 && {
      acceptedOdds: initialState.acceptedOdds,
      opportunities: initialState.opportunities
    })
  };
};

export default selectionRemoved;
